import React from 'react';
import { Dialog } from 'office-ui-fabric-react/lib/Dialog';
import styled from 'styled-components';
import style from './DialogPopUp.style';

const DialogPopUp = ({ children, className, ...rest }) => (
    <Dialog {...rest} className={className}>
        {children}
    </Dialog>
);
export default styled(DialogPopUp)`
    ${style};
`;
